import { useQuery } from '@hooks/reactQuery';

import { getAlarmsNoFileNetworkElements } from '@api/alarmManagement';

import { optionsFormattedWithIdName } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { ALARM_CUSTOM_ALARMS_NO_FILE_NETWORK_ELEMENTS } from '@constants/queryKeys';

interface IUseQueryAlarmsNoFileNetworkElementsReturn {
	isLoadingAlarmsNoFileNetworkElements: boolean;
	noFileNetworkElementsOptions: TSelectOption[];
}

export const useQueryAlarmsNoFileNetworkElements = (): IUseQueryAlarmsNoFileNetworkElementsReturn => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [ALARM_CUSTOM_ALARMS_NO_FILE_NETWORK_ELEMENTS],
		queryFn: getAlarmsNoFileNetworkElements,
		select: optionsFormattedWithIdName,
		refetchOnWindowFocus: false,
	});

	return {
		isLoadingAlarmsNoFileNetworkElements: isInitialLoading,
		noFileNetworkElementsOptions: data || [],
	};
};
